<template>
  <div v-if="hallmark" class="product-card-hallmark">
    <img class="product-card-hallmark__icon" :src="hallmark.icon" alt="" />
    <span class="product-card-hallmark__text">
      {{ hallmark.label }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  value?: string | null
}>()

const hallmarkMap: Record<string, { label: string; icon: string }> = {
  'One of a Kind': {
    label: 'One of a Kind',
    icon: 'https://cdn.shopify.com/s/files/1/2299/7239/files/JH_1_1_HALLMARK.svg?v=1775443005',
  },
  Editions: {
    label: 'J.H. Editions',
    icon: 'https://cdn.shopify.com/s/files/1/2299/7239/files/JH_EDITIONS_HALLMARK.svg?v=1775443005',
  },
  Ceremony: {
    label: 'Ceremony',
    icon: 'https://cdn.shopify.com/s/files/1/2299/7239/files/JH_CEREMONY_HALLMARK.svg?v=1775443005',
  },
}

const hallmark = computed(() => {
  if (!props.value) return null
  return hallmarkMap[props.value] || null
})
</script>

<style lang="scss">
.product-card-hallmark {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 8px;

  &__icon {
    display: block;
    height: 15px;
    width: auto;
  }

  &__text {
    font-size: var(--font-xs);
    line-height: var(--font-lh-xs);
    letter-spacing: 0.02em;
    padding-top: 1.5px;
    opacity: 0;
    transition: opacity 0.15s ease;
    white-space: nowrap;
    color: var(--color-light);
  }
}

@media (hover: hover) {
  .product-card:hover .product-card-hallmark__text,
  .product-card:focus-within .product-card-hallmark__text,
  .home-section-products-card:hover .product-card-hallmark__text,
  .home-section-products-card:focus-within .product-card-hallmark__text {
    opacity: 1;
  }
}
</style>
